import React from 'react';
import { Helmet } from 'react-helmet-async';
import Opportunities from './Opportunities';
import useRouter from '../../hooks/useRouter';
import PageHeader from '../people-people/PageHeader';

export default function Layout(props) {
  const router = useRouter();

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore active projects and events</title>
      </Helmet>
      <PageHeader
        title="Explore active projects and events"
        subtitle={(
          <>
            Check out inspiring projects and events where educators and learners are looking
            for partners. See how you can connect and contribute your skills and experiences to
            make a difference. Use filters to find projects and events that interest you.
          </>
        )}
      />
      <Opportunities
        router={router}
      />
    </div>
  );
}
